import { IMenu } from '@dfl/mui-react-common';
import { AudiLogIcon, RoleIcon, UserIcon } from 'modules/security/common/components/icons';
import { ProviderUserIcon } from 'modules/security/common/components/icons/ProviderUserIcon';
import { ROLE_PERMISSIONS } from 'modules/security/roles/interfaces/permissions';
import { USER_PERMISSIONS } from 'modules/security/users/constants/user.permissions';

export const SECURITY_MENU: Array<IMenu & { modulePath?: string; items: any[] }> = [
  {
    title: 'main_menu.admin.section.security.title',
    prefix: '/security',
    atLessOne: true,
    items: [
      {
        title: 'main_menu.admin.section.security.users',
        path: '/security/system-users/all',
        modulePath: '/security/system-users',
        icon: <UserIcon fontSize='small' />,
        permissions: [USER_PERMISSIONS.ADMIN],
        partialMatch: true,
      },
      {
        title: 'main_menu.admin.section.security.usersProviders',
        path: '/security/providers-users/all',
        modulePath: '/security/providers-users',
        icon: <ProviderUserIcon fontSize='small' />,
        permissions: [USER_PERMISSIONS.PROVIDER_USER_VIEW],
        partialMatch: true,
      },
      {
        title: 'main_menu.admin.section.security.roles',
        path: '/security/roles/system',
        modulePath: '/security/roles',
        partialMatch: true,
        icon: <RoleIcon fontSize='small' />,
        permissions: [ROLE_PERMISSIONS.ROLE_VIEW],
      },
      {
        title: 'main_menu.admin.section.security.auditLogs',
        path: '/security/audit-logs',
        partialMatch: true,
        icon: <AudiLogIcon fontSize='small' />,
        permission: [USER_PERMISSIONS.ADMIN],
      },
    ],
  },
];
